import React from 'react';
import { SiteContent } from '../data/content';

interface AboutContextProps {
  content: SiteContent['aboutContext'];
}

export const AboutContext: React.FC<AboutContextProps> = ({ content }) => {
  return (
    <section className="about-section" id="about" aria-labelledby="about-title">
      <div className="container">
        <div className="about-grid">
          <div className="about-copy">
            <p className="eyebrow">{content.eyebrow}</p>
            <h2 id="about-title" className="section-title">
              {content.title} <em>{content.titleEmphasis}</em>
            </h2>
            <div className="about-paras">
              {content.paragraphs.map((p, idx) => (
                <p key={idx}>{p}</p>
              ))}
            </div>
          </div>

          <div className="about-tags-block" aria-label="Core competencies">
            <span className="tags-label">CORE DOMAINS:</span>
            <div className="tags-list">
              {content.tags.map((tag, idx) => (
                <span key={idx} className="domain-tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
